import { render, staticRenderFns } from "./GroupLogin.vue?vue&type=template&id=386be27e&scoped=true"
import script from "./GroupLogin.vue?vue&type=script&lang=js"
export * from "./GroupLogin.vue?vue&type=script&lang=js"
import style0 from "./GroupLogin.vue?vue&type=style&index=0&id=386be27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386be27e",
  null
  
)

export default component.exports